type IntercomFn = (action: string) => void;

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Intercom(action: string): void {
  const realIntercom: IntercomFn = window["Intercom"];
  if (realIntercom) {
    realIntercom(action);
  }
}
